import { render, staticRenderFns } from "./quickABColorIcon.vue?vue&type=template&id=5ae6d754&"
import script from "./quickABColorIcon.vue?vue&type=script&lang=js&"
export * from "./quickABColorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports